// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchField_root__xyrA8","root_shade":"SearchField_root_shade__7xvUj"};